import XYZ from "ol/source/XYZ";
import TileState from "ol/TileState";
import { db } from "../db";
import { getCurrentSettings } from '../stores/settings';
const getShouldCache = async (layer) => {
    const store = await getCurrentSettings();
    return store.baseLayers[layer.name].cache;
};
export const getCacheId = (props, tile) => `${props.name}/${tile[2]}/${tile[0]}/${tile[1]}`;
export const getTileCacher = (props) => async (tile, source) => {
    const shouldCache = getShouldCache(props);
    const cacheId = getCacheId(props, tile);
    let data;
    if (shouldCache) {
        const tile = await db.tiles.get(cacheId);
        data = tile === null || tile === void 0 ? void 0 : tile.data;
    }
    if (!data) {
        const response = await fetch(source);
        data = await response.blob();
        if (shouldCache) {
            db.tiles.put({ id: cacheId, data, layer: props.name }, cacheId);
        }
    }
    return URL.createObjectURL(data);
};
export default (options) => {
    const cacher = getTileCacher(options);
    const { url, ...rest } = options;
    if (typeof url === "string")
        rest["url"] = url;
    else
        rest.tileUrlFunction = url;
    return new XYZ({
        ...rest,
        tileLoadFunction: async (tile, source) => {
            try {
                const url = await cacher(tile.getTileCoord(), source);
                const image = tile['getImage']();
                image.src = url;
            }
            catch (err) {
                tile.setState(TileState.ERROR);
            }
        }
    });
};
